import { createLazyComponent } from '@muse-web/router'
import { DESKTOP_MEDIA_QUERY, whenMediaMatches } from '@core/media'
import type { THydratedNavigationProps } from './Navigation.types'
import { NavigationPlaceholder } from './NavigationPlaceholder'

const loadNavigation = () =>
    import(/* webpackChunkName: 'header-navigation' */ './HydratedNavigation')

const whenDesktop = () => whenMediaMatches(DESKTOP_MEDIA_QUERY)

export const AsyncNavigation = createLazyComponent<THydratedNavigationProps, 'HydratedNavigation'>(
    loadNavigation,
    'HydratedNavigation',
    { keepServerMarkup: true, fallback: NavigationPlaceholder, waitFor: whenDesktop },
)
